// extracted by mini-css-extract-plugin
export default {"market":"Market_market__oUVYx","table":"Market_table__-TTMq","row":"Market_row__nErXt","col":"Market_col__iopYV","foot":"Market_foot__t4sDs","arrow":"Market_arrow__iUoqF"};